import {
  LocationOn as LocationOnIcon,
  Schedule as ScheduleIcon,
} from '@mui/icons-material';
import { CalendarToday as CalendarTodayIcon } from '@mui/icons-material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { MiniSidebar } from 'src/components/sidebar/miniSidebar';
import { Item } from 'src/components/sidebar/miniSidebar/MiniSidebar.interface';
import { PATHS } from 'src/constants/paths';
import { getPaths, lang, useUserRole } from 'src/utils';

import { Container, Content } from './LocationGroupSubNavbar.styled';

export const LocationGroupSubNavbar = () => {
  const { locationGroupId = '' } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const paths = getPaths(location.pathname).slice(1);

  const schedulePath = PATHS.LOCATION_GROUP_SCHEDULE(locationGroupId);
  const timingsPath = PATHS.LOCATION_GROUP_TIMINGS(locationGroupId);
  const detailsPath = PATHS.LOCATION_GROUP_DETAILS(locationGroupId);
  const assignPath = PATHS.LOCATION_GROUP_ASSIGN(locationGroupId);
  const calendarPath = PATHS.LOCATION_GROUP_CALENDAR(locationGroupId);

  const { isViewOnly } = useUserRole();

  const items = [
    {
      icon: <InfoOutlinedIcon />,
      onClick: () =>
        navigate({
          pathname: detailsPath,
        }),
      isSelected: paths.includes(detailsPath),
      tooltipMessage: lang.locationGroupDetails,
    },
    {
      icon: <CalendarTodayIcon />,
      onClick: () =>
        navigate({
          pathname: calendarPath,
          search: location.search,
        }),
      isSelected: paths.includes(schedulePath) || paths.includes(calendarPath),
      tooltipMessage: lang.locationGroupSchedule,
    },
    {
      icon: <ScheduleIcon />,
      onClick: () =>
        navigate({
          pathname: timingsPath,
          search: location.search,
        }),
      isSelected: paths.includes(timingsPath),
      tooltipMessage: lang.locationGroupTimings,
    },
    !isViewOnly && {
      icon: <LocationOnIcon />,
      onClick: () =>
        navigate({
          pathname: assignPath,
          search: location.search,
        }),
      isSelected: paths.includes(assignPath),
      tooltipMessage: lang.addLocations,
    },
  ].filter(Boolean) as Item[];

  return (
    <Container>
      <MiniSidebar items={items} />
      <Content>
        <Outlet />
      </Content>
    </Container>
  );
};
